module.exports = __webpack_public_path__ + "img/faq_superintendent.b0979286.jpg";